import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { CategoryService } from '@app/services/Category/category.service';
import { UserService } from '@app/services/User/user.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PaymentService } from '@app/services/Payment/payment.service';
import { BusinessDetailsService } from '@app/services/BusinessDetails/businessDetails.service';
import { environment } from '../../../../environments/environment.prod';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  public userIsAuthenticated = false;
  categories: any[] = [];
  items:any;
  ItemCount:any;
  
  userInfoId:any;
  profileImageURL:any;
  firstName:any;
  lastName:any;

  getUUID() {
    var isuuid = localStorage.getItem('UUID');
    return isuuid;
  }

  //For toggle modal
  addRemoveClass: boolean = false;
  clickEvent() {
    this.addRemoveClass = !this.addRemoveClass;
  }
  
  toggleClass: boolean = false;
  menuToggleEvent() {
    this.toggleClass = !this.toggleClass;
  }

  menuClass: boolean = false;
  mobileMenuToggle() {
    this.menuClass = !this.menuClass;
  }
  
  form!: FormGroup;
  serverImgUrl = environment.IMG_URL;

  constructor(
    private router: Router,
    private userService: UserService,
    private categoryService: CategoryService,
    private cartService: PaymentService,
    private businessService: BusinessDetailsService,
  ) { 
    this.form = new FormGroup({
      selectedType: new FormControl(null, [Validators.required]),
      searchString: new FormControl(null, [Validators.required]),
      selectedCategory: new FormControl(null, [Validators.required])
    });
  }

  ngOnInit(): void {
    this.userInfoId = this.getUUID();
    this.userIsAuthenticated = this.userService.isLoggedIn();
    if(this.userIsAuthenticated){
      if(this.userInfoId){
        this.fetchUserData();
        this.fetchProfileImgById();
      }
    }

    this.categoryDrop();
    this.basektItem();
  }

  basektItem(){
    this.items = this.cartService.getItems();
    if(this.items){
      this.ItemCount = this.items.length;
    } else {
      this.ItemCount = 0;
    }
  }

  ngAfterViewInit() {
    $(".main-menu").addClass("nav-holder");
    this.userIsAuthenticated = this.userService.isLoggedIn();
  }

  onLogout() {
    Swal.fire({
      title: "Do you want to logout?",
      showDenyButton: true,
      confirmButtonText: "Yes",
      denyButtonText: `No`
    }).then((result) => {
      if (result.isConfirmed) {
        this.userService.logout()
        Swal.fire("Logout", "", "success");
        window.location.href = 'login';
        localStorage.removeItem('UUID');
      }
    });

  }

  categoryDrop() {
    this.categoryService.getAll().subscribe({
      next: (response: any) => {
        this.categories = response.data.map((item: any) => {
          return { name: item.CategoryName, id: item.CategoryInfoId };
        });
      }
    });
  }

  onClickToSearch(selectedType:any, selectedCategory:any, searchString:any): void {
    if (this.form.invalid) {
      Swal.fire("Please fill out the search fields.");
      return;
    }
    this.clickEvent();
    if(selectedType == 'products' ){ 
      this.router.navigate(['/products', searchString, selectedCategory]);
    } else if (selectedType == 'business' ) {
      this.router.navigate(['/business', searchString, selectedCategory]);
    } else {
      this.router.navigate(['/business', searchString, selectedCategory]);
    }
  }

  fetchProfileImgById() {
    this.businessService.getProfileImgByUUId(this.userInfoId).subscribe({
      next: (res: any) => {
        const user = res.data.find((user: any) => user.userInfoId === this.userInfoId);
        if (user) {
          const imageURL = user.profileImageURL;
          this.profileImageURL = `${this.serverImgUrl}profiles/${imageURL}`;
        } else {
          this.profileImageURL = `../../assets/images/all/1.jpg`;
        }
      }
    })
  }

  fetchUserData() {
    this.businessService.getBusinessInfoByUUId(this.userInfoId).subscribe({
      next: async (response: any) => {
        const user = response.data.find((user: any) => user.userInfoId === this.userInfoId);
        if (user) {
          this.firstName = user.firstName;
          this.lastName = user.lastName;
        } else {
          await this.userService.getById(this.userInfoId).subscribe({
                next: (res: any) => {
                  const user = res.data[0];
                  const username = user.userName.substring(0, 6);
                  this.firstName = username.charAt(0).toUpperCase() + username.slice(1)
                }
          })
        }
      }
    });
  }

  // singleUserId() {
  //   const targetUUID = localStorage.getItem('UUID');
  //   this.userName.user().subscribe({
  //     next: (res: any) => {
  //       const user = res.data.find((user: any) => user.UUID === targetUUID);
  //       if (user) {
  //         const username = user.UserName.substring(0, 6);
  //         this.singleName = username.charAt(0).toUpperCase() + username.slice(1)
  //       }
  //     },
  //     error: (err: any) => {
  //       Swal.fire("Failed to fetch data");
  //     }
  //   });
  // }
}

